import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { propNames } from "@chakra-ui/styled-system";
import { memoizeOne } from "@chakra-ui/utils";
import isValid from "@emotion/is-prop-valid";
var allPropNames = [].concat(_toConsumableArray(propNames), ["htmlWidth", "htmlHeight", "htmlSize", "__css", "sx"]);

function createShouldForwardProp(props) {
  var regex = new RegExp("^(" + props.join("|") + ")$");
  return memoizeOne(function (prop) {
    return isValid(prop) && !regex.test(prop);
  });
}

export var shouldForwardProp = createShouldForwardProp(allPropNames);